import { lazy } from 'react'
import { SettingOutlined } from '@ant-design/icons'
import lazyComponent from './lazy'
import { SETTING_BUSSINES_ALLOWED_ROLES, SETTING_USER_ALLOWED_ROLES, SETTING_CATALOGS_ALLOWED_ROLES } from '../util/stateAccess'

const Users = lazy(() => import('../containers/Settings/User'))
const Business = lazy(() => import('../containers/Settings/Business'))
const BusinessRequests = lazy(() => import('../containers/Settings/BusinessRequests'))
const CatalogCategories = lazy(() => import('../containers/Settings/Catalogs/Category'))

const states = [
  {
    key: 'view_settings',
    url: 'settings',
    name: 'App.Settings',
    title: 'Configuraciones',
    redirectTo: 'App.Settings.Business',
    data: {
      nav: {
        type: 'menu',
        sort: 1,
        icon: <SettingOutlined />,
      },
      roles: SETTING_BUSSINES_ALLOWED_ROLES,
    },
  },
  {
    key: 'view_settings_business',
    url: '/business',
    name: 'App.Settings.Business',
    title: 'Negocios',
    views: {
      'main@App': lazyComponent(Business),
    },
    data: {
      nav: {
        type: 'menu',
        sort: 2,
      },
      roles: SETTING_BUSSINES_ALLOWED_ROLES,
    },
  },
  {
    key: 'view_settings_business_requests',
    url: '/business-requests',
    name: 'App.Settings.BusinessRequests',
    title: 'Solicitudes de Comercios',
    views: {
      'main@App': lazyComponent(BusinessRequests),
    },
    data: {
      nav: {
        type: 'menu',
        sort: 2,
      },
      roles: SETTING_BUSSINES_ALLOWED_ROLES,
    },
  },
  {
    key: 'view_settings_user',
    url: '/users',
    name: 'App.Settings.Users',
    title: 'Usuarios',
    views: {
      'main@App': lazyComponent(Users),
    },
    data: {
      nav: {
        type: 'menu',
        sort: 2,
      },
      roles: SETTING_USER_ALLOWED_ROLES,
    },
  },
  {
    key: 'view_settings_catalogs',
    url: '/catalogs',
    name: 'App.Settings.Catalogs',
    title: 'Catalogos',
    redirectTo: 'App.Settings.Catalogs.Category',
    data: {
      nav: {
        type: 'menu',
        sort: 2,
      },
      roles: SETTING_CATALOGS_ALLOWED_ROLES,
    },
  },
  {
    key: 'view_settings_catalogs_category',
    url: '/category',
    name: 'App.Settings.Catalogs.Category',
    title: 'Categorías',
    views: {
      'main@App': lazyComponent(CatalogCategories),
    },
    data: {
      nav: {
        type: 'menu',
        sort: 3,
      },
      roles: SETTING_CATALOGS_ALLOWED_ROLES,
    },
  }
]

export default states
